<div class="view-content">
  <div class="sessions">
    @for (session of getSessionsToDisplay(); track session) {
      <div class="session" [ngClass]="{'active': session.id === activeExpedition, 'disabled': locked}" (click)="makeExpeditionActive(session); $event.stopPropagation();">
        <div class="session-info">
          <wm-browser [browser]="session.browser" [showPlatform]="!isHeadlessSession(session)"></wm-browser>
        </div>
        <button pButton type="button" class="p-button-text access" icon="true" [disabled]="locked" tooltipPosition="top" pTooltip="Access console" (click)="accessConsole(session) "><fa-icon [icon]="faDesktop"></fa-icon></button>
        <button pButton type="button" class="p-button-text stop" icon="true" [disabled]="locked" tooltipPosition="top" pTooltip="Stop session" (click)="stopSession(session.id) "><fa-icon [icon]="faStopCircle"></fa-icon></button>
      </div>
    }
    @if ((getSessionsToDisplay() || []).length === 0) {
      <div class="no-session">
        <fa-icon [icon]="faInfoCircle" [fixedWidth]="true"></fa-icon> No sessions running
      </div>
    }
  </div>
  <div class="deploy-button">
    <button pButton [disabled]="locked || startingHeadlessBrowser" [loading]="startingHeadlessBrowser" (click)="startHeadlessBrowser()">Deploy Browser</button>
  </div>
</div>
